import { Card } from "./Layout";
import { Button } from "./ui/button";
import { DAYS, FRANJAS, groupLabel } from "../lib/api";

/** Cuadrante semanal del Centro: una fila por hora, una columna por día. */
export const CentroWeekBoard = ({ roster, onToggleClosed }) => {
  const days = [1, 2, 3, 4, 5];
  const visible = roster.filter((s) => s.active !== false);

  return (
    <Card className="p-4" data-testid="centro-week-board">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h2 className="font-head text-xl font-medium">Cuadrante semanal del centro</h2>
        <p className="text-sm text-ink-700">
          🟢 con plazas · 🔴 completo · pulse "Cerrar grupo" para marcarlo completo a mano
        </p>
      </div>
      <div className="mt-3 overflow-x-auto">
        <table className="w-full border-separate border-spacing-1 text-sm">
          <thead>
            <tr>
              <th className="sticky left-0 z-20 w-24 bg-white p-2 text-left text-xs font-semibold text-ink-700">HORA</th>
              {days.map((d) => (
                <th key={d} className="p-2 text-center font-head text-base font-medium">
                  {DAYS[d].toUpperCase()}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {FRANJAS.map(([start, end]) => {
              const row = visible.filter((s) => s.start >= start && s.start < end);
              if (row.length === 0) return null;
              return (
                <tr key={start}>
                  <th className="sticky left-0 z-10 bg-white p-2 text-left font-head text-sm font-medium text-ink-800">
                    {start}<br /><span className="text-xs text-ink-700">{end}</span>
                  </th>
                  {days.map((d) => {
                    const cells = row.filter((s) => s.day === d);
                    return (
                      <td key={d} className="align-top">
                        {cells.length === 0 ? (
                          <div className="rounded-lg border border-dashed border-border bg-muted/30 p-2 text-center text-xs text-ink-700">
                            Sin clase
                          </div>
                        ) : (
                          <div className="space-y-2">
                            {cells.map((s) => (
                              <div key={s.id} data-testid={`board-slot-${s.id}`}
                                className={`rounded-lg border-2 p-2 ${s.full ? "border-red-300 bg-red-50" : "border-emerald-200 bg-emerald-50"}`}>
                                <div className="flex items-start justify-between gap-2">
                                  <p className="text-xs font-semibold">
                                    {s.label || groupLabel(s.stage_group)}
                                    {s.block ? ` · ${s.block}` : s.kind === "gr" ? " · GR" : ""}
                                  </p>
                                  <span className="whitespace-nowrap text-xs font-bold">
                                    {s.full ? "🔴" : "🟢"} {s.taken}/{s.capacity}
                                  </span>
                                </div>
                                <p className="mt-1 text-xs text-ink-800" data-testid={`board-students-${s.id}`}>
                                  👥 {s.students.length ? s.students.join(", ") : "sin alumnos"}
                                </p>
                                {s.teacher && <p className="mt-1 text-xs text-ink-700">Profesional: {s.teacher}</p>}
                                {s.closed && (
                                  <p className="mt-1 rounded bg-red-200 px-1 text-xs font-semibold text-red-900">
                                    Grupo cerrado a mano
                                  </p>
                                )}
                                <Button data-testid={`board-closed-${s.id}`} variant="outline"
                                  className="mt-2 h-8 w-full px-1 text-xs"
                                  onClick={() => onToggleClosed(s)}>
                                  {s.closed ? "Reabrir grupo" : "Cerrar grupo"}
                                </Button>
                              </div>
                            ))}
                          </div>
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Card>
  );
};
